import React, { useState, useEffect, useContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  TextField,
  Stack,
} from "@mui/material";

import { ApiContext } from "../../Context/Context";
import {
  getRecords,
  getRecords_new,
  PostRecords,
} from "../../Services/ApiCall";

import {
  callApi,
  makeApiRequest,
  sendLandPandaNotification,
} from "../../Services/ApiService";

import {
  BaseUrl,
  Authorization_Token,
  LoggedInUserID,
  LoggedInUserName,
  setLogindata,
  setUserdata,
  staticToken,
} from "../../Services/Urls";
import { formatIndianAmount, getDisplayPrice } from "../../Services/Helper";
import { toast } from "react-toastify";



const ReportDialog = ({ open, onClose, details, onSubmit }) => {
  const [showIssue, setShowIssue] = useState(false);

  const [CategoryData, setCategoryData] = useState([]);
  const [SubCategoryData, setSubCategoryData] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);

  const [Remarks, setRemarks] = useState("");

  useEffect(() => {
    getCatData();
  }, []);

  useEffect(() => {
    if (selectedCategory) {
      getSubCatData();
    }
  }, [selectedCategory]);

  const getCatData = () => {
    getRecords_new(444, 100, `{}`, 1, "", 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setCategoryData(data?.response?.records || []);
          setSelectedCategory(data?.response?.records[0] || null);
        } else {
          setCategoryData([]);
          setSelectedCategory(null);
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getSubCatData = () => {
    getRecords_new(
      445,
      100,
      `{ CategoryID: { $in: [${selectedCategory?.CategoryID}] }}`,
      1,
      "",
      1,
      "",
      (data) => {
        if (data != null) {
          if (data?.hasErrors === false && data?.response?.records != null) {
            setSubCategoryData(data?.response?.records || []);
            // setSelectedCategory(data?.response?.records[0] || null);
          } else {
            setSubCategoryData([]);
            // setSelectedCategory(null);
            console.log("Error in fetching featured properties", data);
          }
        }
      },
    );
  };

  const PostReport = () => {
    const body = [
      {
        User: LoggedInUserName,
        UserID: LoggedInUserID,
        PropertyType: details?.PropertyType,
        PropertyTypeID: details?.PropertyTypeID,
        Vertical: details?.Vertical,
        VerticalID: details?.VerticalID,
        ListingID: details?.ListingID,
        SubCategory: selectedSubCategory?.SubCategory,
        SubCategoryID: selectedSubCategory?.SubCategoryID,
        Category: selectedCategory?.Category,
        CategoryID: selectedCategory?.CategoryID,
        Remarks: Remarks,
      },
    ];

    PostRecords(443, 1, body, (data) => {
      if (data != null && data?.response?.hasErrors === false) {
        toast.success(`Reported Successfully`);
        // setPostedID(data?.response?.response?.clientID);
        // setOpenSuccess(true);

        onClose();
      } else {
        toast.error(`${data?.response?.errors}`);
      }
    });
  };

  return (
    <div className="">
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="xs"
        fullWidth
        className="dialogg feedback-dialog"
      >
        <DialogTitle textAlign="center">
          <div className="header">
            <div className="icon">
              <i class="ri-flag-2-line text-red-600 text-base __web-inspector-hide-shortcut__"></i>
            </div>
            <h3>Give us Feedback</h3>
          </div>
        </DialogTitle>
        <Button
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          ✕
        </Button>

        <DialogContent style={{ marginTop: -25 }}>
          <div className="feedback-modal">
            {!showIssue ? (
              <>
                <p className="desc">
                  You are giving feedback for <b>{details?.Title}</b> located at
                  <b> {details?.Locality}</b> priced{" "}
                  <b>{getDisplayPrice(details)}</b>.
                </p>

                <p className="question">
                  <b> Does this property listing have correct details?</b>
                </p>

                <div className="btn-group">
                  <button className="btn success">
                    <i class="ri-checkbox-circle-line"></i> Yes, details are
                    correct
                  </button>
                  <button
                    className="btn danger"
                    onClick={() => setShowIssue(true)}
                  >
                    <i class="ri-close-circle-line"></i> No, there's an issue
                  </button>
                </div>
              </>
            ) : (
              <>
                <p className="desc">
                  You are giving feedback for <b>{details?.Title}</b> located at
                  <b> {details?.Locality}</b> priced{" "}
                  <b>{getDisplayPrice(details)}</b>.
                </p>

                <p className="question">
                  Help us understand what is the problem with the listing.
                </p>

                <div className="tabs">
                  {CategoryData?.map((data, i) => {
                    return (
                      <button
                        onClick={() => setSelectedCategory(data)}
                        className={
                          selectedCategory?.CategoryID === data?.CategoryID
                            ? "tab active"
                            : "tab"
                        }
                      >
                        {data?.Category}
                      </button>
                    );
                  })}

                  {/* <button className="tab active">✔ Price</button>
                  <button className="tab">Photos</button>
                  <button className="tab">Availability Details</button>
                  <button className="tab">Others</button> */}
                </div>

                <div className="checkboxes">
                  {SubCategoryData?.map((data, i) => (
                    <label key={i}>
                      <input
                        type="radio"
                        name="subcategory"
                        checked={
                          selectedSubCategory?.SubCategoryID ===
                          data?.SubCategoryID
                        }
                        onChange={() => setSelectedSubCategory(data)}
                      />
                      {data?.SubCategory}
                    </label>
                  ))}

                  {/* <label>
                    <input type="checkbox" /> Price Not Updated
                  </label>
                  <label>
                    <input type="checkbox" /> Hidden Charges
                  </label> */}
                </div>

                <span className="feedback-submit">Remarks</span>
                <div className="">
                  <input
                    value={Remarks}
                    style={{ height: 100, width: "100%" }}
                    onChange={(e) => setRemarks(e.target.value)}
                    placeholder="Enter Complaint Description"
                  />
                </div>

                <button
                  onClick={PostReport}
                  disabled={
                    !selectedCategory || !selectedSubCategory
                  }
                  className="submit"
                  style={{
                    backgroundColor:
                      !selectedCategory || !selectedSubCategory
                        ? "#d1d5db"
                        : "#16a34a",
                    cursor:
                  !selectedCategory || !selectedSubCategory
                        ? "not-allowed"
                        : "pointer",
                  }}
                >
                  Submit Feedback
                </button>
              </>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ReportDialog;
